import React from "react";

const SpinnerOverlay: React.FC = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="h-16 w-16 animate-spin rounded-full border-b-4 border-t-4 border-blue-700"></div>
  </div>
);

export default SpinnerOverlay;
